import React, { useEffect, useState } from 'react';
import favicon from "../assets/favicon.png";
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { loginAPI } from '../utils/api';
import { FaMobileAlt } from 'react-icons/fa';
import { Spinner } from 'react-bootstrap';

const Home = () => {
    const [mobile, setMobile] = useState("");
    const [loading, setLoading] = useState(false);
    const [validated, setValidated] = useState(false);
    const [mobileError, setMobileError] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        const ppcid = localStorage.getItem('ppcdata');
        if (ppcid) {
            navigate("/dashboard");
        }
    }, [navigate]);

    const NumericOnly = (e) => {
        const reg = /^[0-9\b]+$/;
        const preval = e.target.value;
        if (e.target.value === '' || reg.test(e.target.value)) {
            setMobile(e.target.value);
        } else {
            e.target.value = preval.substring(0, (preval.length - 1));
        }
    };

    const handleLoginSubmit = async (e) => {
        e.preventDefault();
        setValidated(true);

        const indianMobile = /^[6-9]\d{9}$/;
        if (!mobile) {
            setMobileError('Please provide your Mobile Number');
            return;
        }
        if (!indianMobile.test(mobile)) {
            setMobileError('Please enter a valid 10-digit Indian mobile number');
            return;
        }

        setMobileError('');
        setLoading(true);

        loginAPI("ppc-send-mobile-otp", mobile)
            .then((res) => {
                if (res?.data?.status === 1) {
                    localStorage.setItem("ppcmobile", mobile);
                    toast.success(res.data.msg);
                    navigate("/mobile-otp");
                } else {
                    toast.error(res?.data?.msg || "Unable to send OTP.");
                }
            })
            .catch(() => {
                toast.error("Something went wrong. Please try again.");
            })
            .finally(() => {
                setLoading(false);
            });
    };

    return (
        <div className="login-wrapper">
            <Helmet>
                <title>SATKARTAR: PPC LOGIN</title>
                <link href="https://fonts.googleapis.com/css2?family=Nunito:wght@400;600;700;800;900&display=swap" rel="stylesheet" />
            </Helmet>

            <style>{`
                .login-wrapper {
                    min-height: 100vh;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background: radial-gradient(circle at 50% 0%, #f8fafc 0%, #e2e8f0 100%);
                    font-family: 'Nunito', sans-serif;
                    position: relative;
                    overflow: hidden;
                    padding: 20px;
                }
                .login-wrapper::before {
                    content: '';
                    position: absolute;
                    top: -20%; left: -10%;
                    width: 50vw; height: 50vw;
                    background: radial-gradient(circle, rgba(245,158,11,0.15) 0%, transparent 70%);
                    border-radius: 50%;
                    z-index: 1;
                    pointer-events: none;
                }
                .login-wrapper::after {
                    content: '';
                    position: absolute;
                    bottom: -20%; right: -10%;
                    width: 40vw; height: 40vw;
                    background: radial-gradient(circle, rgba(14,116,144,0.1) 0%, transparent 70%);
                    border-radius: 50%;
                    z-index: 1;
                    pointer-events: none;
                }
                .login-card {
                    background: rgba(255, 255, 255, 0.85);
                    backdrop-filter: blur(20px);
                    -webkit-backdrop-filter: blur(20px);
                    border: 1px solid rgba(255, 255, 255, 0.5);
                    border-radius: 24px;
                    padding: 48px 40px;
                    width: 100%;
                    max-width: 440px;
                    box-shadow: 0 20px 40px -10px rgba(0, 0, 0, 0.08);
                    z-index: 10;
                    position: relative;
                }
                .login-header { text-align: center; margin-bottom: 36px; }
                .login-logo {
                    width: 84px; height: 84px;
                    object-fit: contain;
                    margin-bottom: 20px;
                    border-radius: 20px;
                    background: #fff;
                    padding: 12px;
                    box-shadow: 0 8px 20px rgba(0,0,0,0.06);
                    border: 2px solid rgba(245, 158, 11, 0.3);
                }
                .login-title {
                    color: #0f172a;
                    font-size: 24px;
                    font-weight: 900;
                    letter-spacing: 1.5px;
                    margin: 0;
                }
                .login-subtitle {
                    color: #64748b;
                    font-size: 12px;
                    margin-top: 6px;
                    font-weight: 700;
                    letter-spacing: 0.5px;
                    text-transform: uppercase;
                }
                .portal-badge {
                    display: inline-block;
                    background: linear-gradient(135deg, rgba(245,158,11,0.12), rgba(234,88,12,0.08));
                    border: 1px solid rgba(245,158,11,0.25);
                    color: #b45309;
                    font-size: 10px;
                    font-weight: 800;
                    letter-spacing: 1px;
                    text-transform: uppercase;
                    padding: 4px 12px;
                    border-radius: 999px;
                    margin-top: 10px;
                }
                .login-form-group {
                    margin-bottom: 28px;
                    position: relative;
                }
                .login-label {
                    display: block;
                    color: #475569;
                    font-size: 12px;
                    font-weight: 800;
                    margin-bottom: 8px;
                    text-transform: uppercase;
                    letter-spacing: 0.8px;
                }
                .login-input-wrapper { position: relative; }
                .login-icon {
                    position: absolute;
                    left: 16px;
                    top: 50%;
                    transform: translateY(-50%);
                    color: #94a3b8;
                    font-size: 16px;
                    transition: color 0.3s ease;
                    z-index: 5;
                }
                .login-input {
                    width: 100%;
                    background: #f1f5f9 !important;
                    border: 1px solid #e2e8f0 !important;
                    border-radius: 12px !important;
                    padding: 14px 14px 14px 44px !important;
                    color: #0f172a !important;
                    font-size: 15px !important;
                    font-weight: 700 !important;
                    transition: all 0.3s ease !important;
                    box-shadow: inset 0 2px 4px rgba(0,0,0,0.02) !important;
                    outline: none !important;
                    font-family: 'Nunito', sans-serif !important;
                }
                .login-input::placeholder { color: #94a3b8 !important; font-weight: 600 !important; }
                .login-input:focus {
                    border-color: #f59e0b !important;
                    background: #fff !important;
                    box-shadow: 0 0 0 4px rgba(245, 158, 11, 0.15) !important;
                }
                .login-input.is-invalid {
                    border-color: #ef4444 !important;
                    background: #fff !important;
                }
                .field-error {
                    position: absolute;
                    top: 100%;
                    left: 0;
                    color: #ef4444;
                    font-size: 11.5px;
                    font-weight: 700;
                    margin-top: 4px;
                    display: flex;
                    align-items: center;
                    gap: 4px;
                }
                .login-btn {
                    width: 100%;
                    background: linear-gradient(135deg, #f59e0b, #ea580c) !important;
                    color: #fff !important;
                    border: none !important;
                    border-radius: 12px !important;
                    padding: 12px !important;
                    font-size: 15px !important;
                    font-weight: 800 !important;
                    letter-spacing: 1px !important;
                    text-transform: uppercase !important;
                    transition: all 0.3s ease !important;
                    box-shadow: 0 8px 20px rgba(245, 158, 11, 0.25) !important;
                    display: flex !important;
                    align-items: center !important;
                    justify-content: center !important;
                    gap: 10px !important;
                    margin-top: 12px !important;
                    font-family: 'Nunito', sans-serif !important;
                    cursor: pointer !important;
                }
                .login-btn:hover {
                    transform: translateY(-2px) !important;
                    box-shadow: 0 12px 25px rgba(245, 158, 11, 0.35) !important;
                }
                .login-btn:disabled {
                    opacity: 0.7 !important;
                    transform: none !important;
                    cursor: not-allowed !important;
                }
                .footer-text {
                    text-align: center;
                    margin-top: 24px;
                    color: #64748b;
                    font-size: 11.5px;
                    font-weight: 700;
                    letter-spacing: 0.5px;
                }
            `}</style>

            <div className="login-card">
                <div className="login-header">
                    <img src={favicon} className="login-logo" alt="Satkartar Logo" />
                    <h4 className="login-title">PPC PANEL</h4>
                    <div className="login-subtitle">Secure OTP Authentication</div>
                    <div className="portal-badge">Mobile Login</div>
                </div>

                <form noValidate onSubmit={handleLoginSubmit}>
                    <div className="login-form-group">
                        <label className="login-label" htmlFor="ppc_mobile">Mobile Number</label>
                        <div className="login-input-wrapper">
                            <input
                                type="text"
                                id="ppc_mobile"
                                name="ppc_mobile"
                                className={`login-input${validated && mobileError ? ' is-invalid' : ''}`}
                                placeholder="Enter your 10-digit mobile"
                                maxLength={10}
                                onChange={NumericOnly}
                            />
                            <FaMobileAlt className="login-icon" />
                            {validated && mobileError && (
                                <div className="field-error">! {mobileError}</div>
                            )}
                        </div>
                    </div>

                    {loading ? (
                        <button disabled type="submit" className="login-btn">
                            <Spinner animation="border" size="sm" /> SENDING OTP...
                        </button>
                    ) : (
                        <button type="submit" className="login-btn">SEND MOBILE OTP</button>
                    )}
                </form>

                <div className="footer-text">
                    &copy; {new Date().getFullYear()} Satkartar Life Limited.
                </div>
            </div>
        </div>
    );
};

export default Home;
